import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import AboutGalleryStrip from "../components/AboutGalleryStrip";
import { EditableText, EditableImage } from "../components/live/Editable";
import { useLiveEdit } from "../lib/liveEdit";
import { CheckCircle2, Medal, Trophy, Building2, GraduationCap } from "lucide-react";

const COURSE_TYPES = [
  { text: "Long term 3.5 years courses for students who are class 10 pass or class 12 pass (from all streams)", to: "/courses/long-term" },
  { text: "Long term 2.5 years courses for students who are ITI, Diploma or Btech Graduates (from relevant mechanical, electrical, electronics and allied streams)", to: "/courses/long-term" },
  { text: "Short term practical oriented courses from 1-11 months for Diploma, ITI, Degree and Btech students", to: "/courses/short-term" },
  { text: "Short term customized corporate courses ranging from 1 day to 3 months", to: "/courses/corporate" },
];

const FEATURES = [
  "25,000 sq feet technical training institute",
  "Well-equipped classrooms with computer and projectors",
  "International standard laboratory with learning software and simulators",
  "High technology industrial workshops",
  "World class machinery and didactical equipment from Germany, India, Japan and USA",
  "Curriculum developed by World Class experts from Germany and highly experienced and well trained Indian faculty",
];

const NATIONAL_AWARDS = [
  { medal: "Gold", text: "National Work Skills Competition, 2025 (Tool & Die Making)" },
  { medal: "Gold", text: "National Work Skills Competition, 2025 (Turner - Mechanical)" },
  { medal: "Gold", text: "National Work Skills Competition, 2024 (Plastic Die Engineering)" },
  { medal: "Gold", text: "National Work Skills Competition, 2024 (Tool & Die Making)" },
  { medal: "Gold", text: "National Work Skills Competition, 2017 (Tool & Die Making)" },
  { medal: "Gold", text: "National Work Skills Competition, 2014 (Tool & Die Making)" },
  { medal: "Silver", text: "National Work Skills Competition, 2024 (Fitter - Mechanical)" },
  { medal: "Silver", text: "National Work Skills Competition, 2023 (Milling - Mechanical)" },
  { medal: "Excellence", text: "Medallion of Excellence – India Skills Competition, 2024 (Manufacturing Team Challenge)" },
];

const REGIONAL_AWARDS = [
  { medal: "Winner", text: "Haryana State - IndiaSkills, Mechanical Design, 2026" },
  { medal: "Winner", text: "Haryana State - IndiaSkills, Manufacturing Team Challenge, 2024" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (CNC - Turner)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (Plastic Die Engineering)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (Tool & Die Maker)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (AutoCAD)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (PLC)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (Pneumatics)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (Mechatronics)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2025 (Electrical)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2024 (Plastic Die Engineering)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2024 (Tool & Die Maker)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2024 (Fitter)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2024 (Milling - Mechanical)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2024 (Turner - Mechanical)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2024 (Mechatronics)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2023 (Plastic Die Engineering)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2023 (Tool & Die Maker)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2023 (Turner)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2023 (Miller)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2023 (Fitter)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2022 (PLC - Programmable Logic Control)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North, 2022 (Machinist)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North - 2015 (Mechanical Fitter)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North - 2016 (Tool & Die Making)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North - 2016 (Electronics)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North - 2017 (Tool & Die Making)" },
  { medal: "Gold", text: "Regional Work Skills Competition, North - 2017 above 22 yrs. (Tool & Die Making)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (Fitter)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (Welder)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (Tool & Die Maker)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (AutoCAD)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (Machinist)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (Mechatronics)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2025 (Turner)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2024 (Electrical)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2024 (Machinist)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2024 (Tool & Die Maker)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North, 2023 (Electrical)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North - 2022 (Electrical)" },
  { medal: "Silver", text: "Regional Work Skills Competition, North - 2014 (Tool & Die Making)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North 2025 (Electrical)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North 2025 (Miller - Machinist)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North 2025 (Welding)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North 2023 (Welder)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North 2023 (Miller - Machinist)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North - 2013 (Electrical)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North - 2015 (Mechanical Fitter)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North - 2016 (Electronics)" },
  { medal: "Bronze", text: "Regional Work Skills Competition, North - 2017 (Miller - Machinist)" },
];

const MEDAL_STYLES = {
  Gold: "bg-yellow-400 text-[#0B2A6B]",
  Silver: "bg-slate-300 text-slate-800",
  Bronze: "bg-amber-700 text-white",
  Winner: "bg-[#0B2A6B] text-yellow-400",
  Excellence: "bg-emerald-600 text-white",
};

function AwardRow({ medal, text, delay, path }) {
  return (
    <li
      className="flex items-center gap-3 bg-white rounded-xl border border-slate-100 shadow-sm px-4 py-3 animate-fade-up"
      style={{ animationDelay: `${delay}s` }}
    >
      <span className={`shrink-0 px-2.5 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide ${MEDAL_STYLES[medal] || "bg-slate-200 text-slate-700"}`}>
        {medal}
      </span>
      <EditableText path={path} as="span" className="text-sm text-slate-700">{text}</EditableText>
    </li>
  );
}

export default function AboutPage() {
  const [awardTab, setAwardTab] = useState("national");
  const { editMode } = useLiveEdit();
  const awards = awardTab === "national" ? NATIONAL_AWARDS : REGIONAL_AWARDS;

  return (
    <>
      <PageHero
        path="about.hero"
        kicker="About KIKI"
        title="About Kiki Centre for Technology"
        subtitle="A high quality, international standard technical training institute at IMT Manesar, Gurgaon, Delhi-NCR."
      />

      {/* Story */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <EditableImage
              path="about.story.image"
              src="/assets/kiki/about-main.jpg"
              alt="Kiki Centre for Technology campus"
              className="rounded-3xl shadow-xl overflow-hidden"
              imgClassName="w-full h-full object-cover"
              data-testid="about-main-image"
            />
            <div className="absolute -bottom-5 -right-5 hidden sm:flex items-center gap-3 bg-[#0B2A6B] text-white rounded-2xl px-5 py-4 shadow-lg">
              <Building2 className="h-7 w-7 text-yellow-400" />
              <div>
                <div className="font-bold text-sm">IMT Manesar, Gurgaon</div>
                <div className="text-xs text-slate-300">Delhi-NCR</div>
              </div>
            </div>
          </div>
          <div>
            <p className="kicker mb-3">About KIKI</p>
            <EditableText path="about.story.title" as="h2" className="text-3xl font-bold text-[#0B2A6B] mb-5 block">About Kiki Centre for Technology</EditableText>
            <EditableText
              path="about.story.text"
              as="p"
              multiline
              className="text-slate-600 leading-relaxed block"
              data-testid="about-story-text"
            >
              Established with the support of a World Bank reflows programme, the German Chamber of Skilled Crafts, Koblenz, Germany and Indian industry; Anjali foundation (under the brand name of Kiki Centre for Technology) has established a high quality, international standard technical training institute at IMT Manesar, Gurgaon, Delhi-NCR. The institute focuses on developing skills with the support of German experts.
            </EditableText>
          </div>
        </div>
      </section>

      {/* Campus-life strip */}
      <AboutGalleryStrip />

      {/* Courses conducted */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <p className="kicker mb-3">What we offer</p>
            <EditableText path="about.courseTypes.title" as="h2" className="text-3xl font-bold text-[#0B2A6B] block">Various courses are conducted such as:</EditableText>
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            {COURSE_TYPES.map((c, i) => (
              <Link
                key={c.text}
                to={c.to}
                onClick={(e) => editMode && e.preventDefault()}
                className="group flex items-start gap-4 bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-xl tilt-card animate-fade-up"
                style={{ animationDelay: `${i * 0.07}s` }}
                data-testid={`about-course-type-${i}`}
              >
                <div className="shrink-0 h-11 w-11 rounded-xl bg-yellow-400 flex items-center justify-center">
                  <GraduationCap className="h-6 w-6 text-[#0B2A6B]" />
                </div>
                <EditableText path={`about.courseType.${i}`} as="p" multiline className="text-slate-700 font-medium group-hover:text-[#0B2A6B] transition">{c.text}</EditableText>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <p className="kicker mb-3">Our Institute</p>
            <EditableText path="about.features.title" as="h2" className="text-3xl font-bold text-[#0B2A6B] block">Some of the features of the institute are as follows:</EditableText>
          </div>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {FEATURES.map((f, i) => (
              <li
                key={f}
                className="flex items-start gap-3 bg-white rounded-2xl p-6 border border-slate-100 shadow-sm tilt-card animate-fade-up"
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                <CheckCircle2 className="h-5 w-5 text-yellow-500 mt-0.5 shrink-0" />
                <EditableText path={`about.feature.${i}`} as="span" multiline className="text-slate-700 font-medium">{f}</EditableText>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Awards */}
      <section className="py-20 bg-[#0B2A6B] relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage:
              "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
            backgroundSize: "50px 50px",
          }}
        />
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-10">
            <p className="inline-block px-3 py-1 rounded-full bg-yellow-400/20 border border-yellow-400/40 text-yellow-300 text-xs font-bold tracking-wider uppercase mb-4">
              Our Achievements
            </p>
            <EditableText path="about.awards.title" as="h2" className="text-3xl font-bold text-white mb-4 block">Our students compete — and win</EditableText>
            <EditableText path="about.awards.text" as="p" multiline className="text-slate-300 leading-relaxed block">
              The vigorous learning our students engage in speak for itself. Our students take part in National and Regional level technical competitions against not only other institutes, but against companies such as Maruti, Tata Motors — and our students win. Some of our results are:
            </EditableText>
          </div>

          <div className="flex gap-2 mb-8">
            <button
              onClick={() => setAwardTab("national")}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold transition ${
                awardTab === "national" ? "bg-yellow-400 text-[#0B2A6B]" : "bg-white/10 text-white hover:bg-white/20"
              }`}
              data-testid="awards-tab-national"
            >
              <Trophy className="h-4 w-4" /> National Awards
            </button>
            <button
              onClick={() => setAwardTab("regional")}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold transition ${
                awardTab === "regional" ? "bg-yellow-400 text-[#0B2A6B]" : "bg-white/10 text-white hover:bg-white/20"
              }`}
              data-testid="awards-tab-regional"
            >
              <Medal className="h-4 w-4" /> Regional Awards
            </button>
          </div>

          <ul
            className="grid sm:grid-cols-2 gap-3 max-h-[520px] overflow-y-auto pr-2 rounded-2xl"
            data-testid="awards-list"
          >
            {awards.map((a, i) => (
              <AwardRow key={`${awardTab}-${i}`} medal={a.medal} text={a.text} delay={Math.min(i, 10) * 0.03} path={`about.award.${awardTab}.${i}`} />
            ))}
          </ul>
        </div>
      </section>

      {/* Clients */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="kicker mb-3">Our Clients</p>
          <EditableText path="about.clients.title" as="h2" className="text-3xl font-bold text-[#0B2A6B] mb-5 block">
            The high quality of our courses speak for themselves
          </EditableText>
          <EditableText path="about.clients.text" as="p" multiline className="text-slate-600 leading-relaxed block" data-testid="about-clients-text">
            Some of our clients include: Maruti Suzuki, Stryker (a Fortune 500 medical technologies firm), Becton Dickenson (American medical equipment company), Subros (India's largest automotive air conditioner manufacturer), Denso (Japanese automotive firm), Asahi Glass (India's largest automotive glass manufacturer), IFB (Conglomerate with interests in automotive, agro and home appliances), Boston Scientific (American Medical Devices Company) etc.
          </EditableText>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <EditableText path="about.cta.title" as="h2" className="text-3xl font-bold text-[#0B2A6B] mb-4 block">Ready to start your journey?</EditableText>
          <EditableText path="about.cta.text" as="p" className="text-slate-600 mb-7 block">Join thousands of students who are building careers with Kiki Centre.</EditableText>
          <Link to="/admissions" className="inline-flex items-center px-7 py-3 rounded-lg btn-primary" data-testid="about-apply-btn">
            Apply for Admission
          </Link>
        </div>
      </section>
    </>
  );
}
